// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loaderContainer {
  position: relative;
  height: 90px;
}
.autocompleteDropdownContainer {
  border: 1px solid grey;
  z-index: 1;
  position: absolute;
  background-color: white;
}
.autocompleteDropdownContainer .suggestionItem {
  cursor: pointer;
  padding: 8px;
}
.autocompleteDropdownContainer .suggestionItem.active {
  background-color: #eaeaea;
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/AddressLookup.less"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,YAAA;AACD;AAEA;EACC,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;AAAD;AAJA;EAOE,eAAA;EACA,YAAA;AAAF;AAEE;EACC,yBAAA;AAAH","sourcesContent":[".loaderContainer {\n\tposition: relative;\n\theight: 90px;\n}\n\n.autocompleteDropdownContainer {\n\tborder: 1px solid grey;\n\tz-index: 1;\n\tposition: absolute;\n\tbackground-color: white;\n\n\t.suggestionItem {\n\t\tcursor: pointer;\n\t\tpadding: 8px;\n\n\t\t&.active {\n\t\t\tbackground-color: #eaeaea;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
